import "globalthis-polyfill"
import queueMicrotask from "queue-microtask"

if (typeof window.queueMicrotask !== "function") {
  window.queueMicrotask = queueMicrotask
}
